<template>

<form-wizard>
  <template v-slot="{formData, stepFormUrl}">
    <tab data-vv-scope="step1" :selected="!stepFormUrl || (stepFormUrl && (stepFormUrl < 1 || stepFormUrl > 10)) ? true : false">
      <div id="form-step-1">
        <div class="text">
          <h1>Votre satisfaction est notre priorité !</h1>
          <p>Prenez quelques minutes et évaluez votre magasin So.bio.<br />Votre avis est précieux pour nous améliorer</p>
        </div>
      </div>
    </tab>
    <tab data-vv-scope="step2">
      <div id="form-step-2">
        <div class="field">
          <div class="text">
            <h2>Suite à votre dernière visite, recommanderiez-vous votre magasin So.bio à votre entourage ?</h2>
            <small class="help-error" v-show="errors.has('step2.question1')">Merci de faire votre choix</small>
            <div class="form-container radio-group d-flex justify-content-between">
              <div v-for="n in 10" v-bind:key="n" class="radio_group">
                <input type="radio" :id="'radio2_step'+n" v-model="formData.question1" name="question1" v-validate="'required'" data-vv-scope="step2" :value="n" />
                <label :for="'radio2_step'+n" class="radio">
                  <svg class="rating">
                      <use href="#rating-svg" xlink:href="#rating-svg" />
                  </svg>
                  {{n}}
                </label>
              </div>
            </div>
            <div class="radio-notice d-flex justify-content-between">
              <span class="min">PAS<br /> DU TOUT</span>
              <span class="max">TOUT<br /> À FAIT</span>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab data-vv-scope="step3" :selected="stepFormUrl && stepFormUrl >= 1 && stepFormUrl <= 10 ? true : false">
      <div id="form-step-3">
        <div class="field">
          <div class="text">
            <h2>Pourriez-vous nous indiquer pourquoi vous avez mis cette note ?</h2>
            <small class="help-error" v-show="errors.has('step3.question2')">Merci de nous indiquer une raison</small>
            <div class="form-container my-4">
              <textarea :id="'textarea_question2'" v-model="formData.question2" name="question2" v-validate="'required'" data-vv-scope="step3"></textarea>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab data-vv-scope="step4">
      <div id="form-step-4">
        <div class="field">
          <div class="text">
            <h2>Quel est votre niveau de satisfaction sur les critères suivants ?</h2>
            <div class="form-container emoji-group">
              <h3>Le choix des produits proposés</h3>
              <small class="help-error" v-show="errors.has('step4.question3')">Merci de faire votre choix</small>
              <div class="row d-flex justify-content-between">
                <div v-for="(item) in emojiList" class="emoji_group col">
                  <input type="radio" :id="'radio3_step'+item.id" v-model="formData.question3" name="question3" v-validate="'required'" data-vv-scope="step4" :value="item.id" />
                  <label :for="'radio3_step'+item.id" class="radio">
                    <svg class="rating">
                        <use :href="'#emoji_'+item.id+'-svg'" :xlink:href="'#emoji_'+item.id+'-svg'" />
                    </svg>
                    {{item.label}}
                  </label>
                </div>
              </div>
            </div>
            <div class="form-container emoji-group">
              <h3>Le choix des produits locaux</h3>
              <small class="help-error" v-show="errors.has('step4.question4')">Merci de faire votre choix</small>
              <div class="row d-flex justify-content-between">
                <div v-for="(item) in emojiList" class="emoji_group col">
                  <input type="radio" :id="'radio4_step'+item.id" v-model="formData.question4" name="question4" v-validate="'required'" data-vv-scope="step4" :value="item.id" />
                  <label :for="'radio4_step'+item.id" class="radio">
                    <svg class="rating">
                        <use :href="'#emoji_'+item.id+'-svg'" :xlink:href="'#emoji_'+item.id+'-svg'" />
                    </svg>
                    {{item.label}}
                  </label>
                </div>
              </div>
            </div>
            <div class="form-container emoji-group">
              <h3>La disponibilité des produits (rayons remplis)</h3>
              <small class="help-error" v-show="errors.has('step4.question5')">Merci de faire votre choix</small>
              <div class="row d-flex justify-content-between">
                <div v-for="(item) in emojiList" class="emoji_group col">
                  <input type="radio" :id="'radio5_step'+item.id" v-model="formData.question5" name="question5" v-validate="'required'" data-vv-scope="step4" :value="item.id" />
                  <label :for="'radio5_step'+item.id" class="radio">
                    <svg class="rating">
                        <use :href="'#emoji_'+item.id+'-svg'" :xlink:href="'#emoji_'+item.id+'-svg'" />
                    </svg>
                    {{item.label}}
                  </label>
                </div>
              </div>
            </div>
            <div class="form-container emoji-group">
              <h3>Les prix en général</h3>
              <small class="help-error" v-show="errors.has('step4.question6')">Merci de faire votre choix</small>
              <div class="row d-flex justify-content-between">
                <div v-for="(item) in emojiList" class="emoji_group col">
                  <input type="radio" :id="'radio6_step'+item.id" v-model="formData.question6" name="question6" v-validate="'required'" data-vv-scope="step4" :value="item.id" />
                  <label :for="'radio6_step'+item.id" class="radio">
                    <svg class="rating">
                        <use :href="'#emoji_'+item.id+'-svg'" :xlink:href="'#emoji_'+item.id+'-svg'" />
                    </svg>
                    {{item.label}}
                  </label>
                </div>
              </div>
            </div>
            <div class="form-container emoji-group">
              <h3>L’intérêt des promotions</h3>
              <small class="help-error" v-show="errors.has('step4.question7')">Merci de faire votre choix</small>
              <div class="row d-flex justify-content-between">
                <div v-for="(item) in emojiList" class="emoji_group col">
                  <input type="radio" :id="'radio7_step'+item.id" v-model="formData.question7" name="question7" v-validate="'required'" data-vv-scope="step4" :value="item.id" />
                  <label :for="'radio7_step'+item.id" class="radio">
                    <svg class="rating">
                        <use :href="'#emoji_'+item.id+'-svg'" :xlink:href="'#emoji_'+item.id+'-svg'" />
                    </svg>
                    {{item.label}}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab data-vv-scope="step5">
      <div id="form-step-5">
        <div class="field">
          <div class="text">
            <h2>Quel est votre niveau de satisfaction sur les critères suivants ?</h2>
            <div class="form-container emoji-group">
              <h3>La qualité des produits en général</h3>
              <small class="help-error" v-show="errors.has('step5.question8')">Merci de faire votre choix</small>
              <div class="row d-flex justify-content-between">
                <div v-for="(item) in emojiList" class="emoji_group col">
                  <input type="radio" :id="'radio8_step'+item.id" v-model="formData.question8" name="question8" v-validate="'required'" data-vv-scope="step5" :value="item.id" />
                  <label :for="'radio8_step'+item.id" class="radio">
                    <svg class="rating">
                        <use :href="'#emoji_'+item.id+'-svg'" :xlink:href="'#emoji_'+item.id+'-svg'" />
                    </svg>
                    {{item.label}}
                  </label>
                </div>
              </div>
            </div>
            <div class="form-container emoji-group">
              <h3>La fraîcheur des fruits et légumes</h3>
              <small class="help-error" v-show="errors.has('step5.question9')">Merci de faire votre choix</small>
              <div class="row d-flex justify-content-between">
                <div v-for="(item) in emojiList" class="emoji_group col">
                  <input type="radio" :id="'radio9_step'+item.id" v-model="formData.question9" name="question9" v-validate="'required'" data-vv-scope="step5" :value="item.id" />
                  <label :for="'radio9_step'+item.id" class="radio">
                    <svg class="rating">
                        <use :href="'#emoji_'+item.id+'-svg'" :xlink:href="'#emoji_'+item.id+'-svg'" />
                    </svg>
                    {{item.label}}
                  </label>
                </div>
              </div>
            </div>
            <div class="form-container emoji-group">
              <h3>L’accueil de l’équipe en magasin</h3>
              <small class="help-error" v-show="errors.has('step5.question10')">Merci de faire votre choix</small>
              <div class="row d-flex justify-content-between">
                <div v-for="(item) in emojiList" class="emoji_group col">
                  <input type="radio" :id="'radio10_step'+item.id" v-model="formData.question10" name="question10" v-validate="'required'" data-vv-scope="step5" :value="item.id" />
                  <label :for="'radio10_step'+item.id" class="radio">
                    <svg class="rating">
                        <use :href="'#emoji_'+item.id+'-svg'" :xlink:href="'#emoji_'+item.id+'-svg'" />
                    </svg>
                    {{item.label}}
                  </label>
                </div>
              </div>
            </div>
            <div class="form-container emoji-group">
              <h3>La propreté du magasin</h3>
              <small class="help-error" v-show="errors.has('step5.question11')">Merci de faire votre choix</small>
              <div class="row d-flex justify-content-between">
                <div v-for="(item) in emojiList" class="emoji_group col">
                  <input type="radio" :id="'radio11_step'+item.id" v-model="formData.question11" name="question11" v-validate="'required'" data-vv-scope="step5" :value="item.id" />
                  <label :for="'radio11_step'+item.id" class="radio">
                    <svg class="rating">
                        <use :href="'#emoji_'+item.id+'-svg'" :xlink:href="'#emoji_'+item.id+'-svg'" />
                    </svg>
                    {{item.label}}
                  </label>
                </div>
              </div>
            </div>
            <div class="form-container emoji-group">
              <h3>Le temps de passage en caisse</h3>
              <small class="help-error" v-show="errors.has('step5.question12')">Merci de faire votre choix</small>
              <div class="row d-flex justify-content-between">
                <div v-for="(item) in emojiList" class="emoji_group col">
                  <input type="radio" :id="'radio12_step'+item.id" v-model="formData.question12" name="question12" v-validate="'required'" data-vv-scope="step5" :value="item.id" />
                  <label :for="'radio12_step'+item.id" class="radio">
                    <svg class="rating">
                        <use :href="'#emoji_'+item.id+'-svg'" :xlink:href="'#emoji_'+item.id+'-svg'" />
                    </svg>
                    {{item.label}}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab data-vv-scope="step6">
      <div id="form-step-6">
        <div class="field">
          <div class="text">
            <h2>Acceptez-vous d’être recontacté dans le cadre de cette étude ?</h2>
            <small class="help-error" v-show="errors.has('step6.question13')">Merci de faire votre choix</small>
            <div class="form-container radio-list">
              <div class="radio_list">
                <input type="radio" id="radio6_step13" v-model="formData.question13" name="question13" v-validate="'required'" data-vv-scope="step6" value="1" />
                <label for="radio6_step13" class="radio d-flex align-items-center">
                  <span class="round"></span>
                  Oui
                </label>
              </div>
              <div class="radio_list">
                <input type="radio" id="radio6_step14" v-model="formData.question13" name="question13" v-validate="'required'" data-vv-scope="step6" value="0" />
                <label for="radio6_step14" class="radio d-flex align-items-center">
                  <span class="round"></span>
                  Non
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tab>
    <tab data-vv-scope="step7">
      <div id="form-step-7">
        <div class="field">
          <div class="text">
            <h2>Le questionnaire est terminé !</h2>
            <p>Nous vous remercions pour votre participation</p>
            <br />
            <br />
            <small>Vous allez être redirigé vers le site www.sobio.fr ...</small>
          </div>
        </div>
      </div>
    </tab>
  </template>
</form-wizard>


</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import FormWizard from './components/FormWizard.vue';
import Tab from './components/Tab.vue';

Vue.use(VeeValidate);

export default {
  name: 'app',
  components: {
    FormWizard, Tab
  },
  data(){
    return{
        emojiList:[
            { id: 1, label: 'Pas du tout satisfait' },
            { id: 2, label: 'Pas tellement satisfait' },
            { id: 3, label: 'Assez satisfait' },
            { id: 4, label: 'Très satisfait' },
            { id: 0, label: 'Ne sait pas' }
        ]
    }
   },
   getXlink:function(str){
    return str;
  }
}
</script>
